import { useEffect, useRef } from 'react';

export default function useUpdateEffect(callback, depArray) {
  const isCalled = useRef(false);
  useEffect(() => {
    if (!isCalled.current) {
      isCalled.current = true;
      return;
    }
    if (callback) {
      callback();
    }
  }, [...depArray]);
}
